import { Injectable } from "@angular/core";


import {
    GetDayViewArgs,
    DayView,
    DayViewEvent
  } from 'calendar-utils';


@Injectable()
export class DashboardDataService {
    constructor() {}

}

export interface MyDayView extends DayView {
    users?: any[];
  }





// WEBPACK FOOTER //
// ./src/app/appointments/dashboard/dashboard-data.service.ts